import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import GreenSpinner from "../../../Shared/Loading/GreenSpinner";

const PaidInvoiceGreenAll = () => {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [userId, setUserId] = useState(""); // State to hold the userId input
  const [totalSalary, setTotalStudentsSalary] = useState("");

  const fetchJobs = useCallback(async () => {
    try {
      const response = await axios.get("https://tutor-tree-server-1.vercel.app/invoice-paid-green", {
        params: {
          page,
          limit: 10,
          userId,  // Include the userId in the query parameters
        },
      });
  

  
      // Calculate total StudentsSalary
 
      const { result, pages, total, totalSalary } = response.data;
      setJobs(result);
      setTotalPages(pages);
    
  
      setTotalStudentsSalary(totalSalary); 
    } catch (err) {
        
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [page, userId]);

  useEffect(() => {
    fetchJobs();
  }, [fetchJobs]);

  const handleUserIdChange = (e) => {
    setUserId(e.target.value);
  };

  const handleSearch = () => {
    setPage(1); // Reset to the first page when searching
    fetchJobs(); // Fetch jobs based on userId
  };

  if (loading) {
    return <GreenSpinner />;
  }
  const formatDate = (dateString) => {
    // Extract the relevant parts of the date string
    const [datePart, timePart] = dateString.split('T');
    const [year, month, day] = datePart.split('-');
    
    // Construct the date in DD/MM/YYYY format
    const formattedDate = `${day}/${month}/${year}`;
    
    return formattedDate;
  };
  return (
    <div className="bg-white h-screen">
      <div className="w-full py-2 flex justify-start pl-5 items-center bg-green-500 shadow-md">
        <h2 className="text-xl text600 text-start text-white font-montserrat">
          Paid Invoices
        </h2>
      </div>
      
      <div className="flex justify-between items-center py-4 px-6 bg-green-50 w-full">
        <input
          type="text"
          value={userId}
          onChange={handleUserIdChange}
          placeholder="Enter User ID"
          className="border border-green-400 rounded p-2"
        />
  
      </div>

      <div className="w-full bg-white mt-5">
        <div className="overflow-x-auto h-[600px]">
          <table className="w-full text-sm text-left text-gray-500">
            <thead className="text-xs text-white uppercase bg-green-500">
              <tr>
                <th className="px-6 py-3">#</th>
                <th className="px-6 py-3">Job Id</th>
                <th className="px-6 py-3">Bkash Invoice Id</th>
                <th className="px-6 py-3">Payment Id</th>
                <th className="px-6 py-3">TRX Id</th>
                <th className="px-6 py-3">Date</th>
                <th className="px-6 py-3">Amount</th>
              </tr>
            </thead>
            <tbody>
              {jobs.map((job, index) => (
                <tr key={index} className="bg-white border-b hover:bg-gray-50">
                  <th className="px-6 py-4 font-medium text-gray-900">
                    {index + 1}
                  </th>
                  <td className="px-6 py-4">{job.userId}</td>
                  <td className="px-6 py-4">{job.bkashInvoiceId.slice(-6)}</td>
                  <td className="px-6 py-4">{job.paymentID}</td>
                  <td className="px-6 py-4">{job.trxID}</td>
                  <td className="px-6 py-4">{formatDate(job.date)}</td>
                  <td className="px-6 py-4">{job.amount} TK</td>
                </tr>
              ))}

            </tbody>
            <thead class="text-xs text-green-900 uppercase bg-green-200 dark:bg-gray-700 dark:text-gray-400">
                <tr>
                  <th scope="col" class="px-6 py-3">
                   
                  </th>

                  <th scope="col" class="px-6 py-3">
                   
                  </th>
                  <th scope="col" class="px-6 py-3">
                   
                  </th>
                  <th scope="col" class="px-6 py-3">
                   
                  </th>
                  <th scope="col" class="px-6 py-3">
                   
                  </th>
                
                  <th scope="col" class="px-6 py-3">
                   
                  </th>
                
                  <th scope="col" class="px-6 py-3">
                    {totalSalary} Tk
                  </th>
                 
           
                </tr>
              </thead>
          </table>
        </div>
        <div className="flex justify-center items-start ">
              <div className="flex justify-between my-5 w-[300px]">
                <button onClick={() => setPage(page - 1)} disabled={page === 1}>
                  <img
                    className="w-10"
                    alt=""
                    src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiB4PSIwIiB5PSIwIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTEyIDUxMiIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgY2xhc3M9IiI+PGcgdHJhbnNmb3JtPSJtYXRyaXgoLTEsLTEuMjI0NjQ2Nzk5MTQ3MzUzMmUtMTYsMS4yMjQ2NDY3OTkxNDczNTMyZS0xNiwtMSw1MTIsNTEyKSI+PHBhdGggZD0iTTI1NiAwQzExNC44MzcgMCAwIDExNC44MzcgMCAyNTZzMTE0LjgzNyAyNTYgMjU2IDI1NiAyNTYtMTE0LjgzNyAyNTYtMjU2UzM5Ny4xNjMgMCAyNTYgMHptNzkuMDgzIDI3MS4wODNMMjI4LjQxNiAzNzcuNzQ5QTIxLjI3NSAyMS4yNzUgMCAwIDEgMjEzLjMzMyAzODRhMjEuMjc3IDIxLjI3NyAwIDAgMS0xNS4wODMtNi4yNTFjLTguMzQxLTguMzQxLTguMzQxLTIxLjgyNCAwLTMwLjE2NUwyODkuODM1IDI1NmwtOTEuNTg0LTkxLjU4NGMtOC4zNDEtOC4zNDEtOC4zNDEtMjEuODI0IDAtMzAuMTY1czIxLjgyNC04LjM0MSAzMC4xNjUgMGwxMDYuNjY3IDEwNi42NjdjOC4zNDEgOC4zNDEgOC4zNDEgMjEuODIzIDAgMzAuMTY1eiIgZmlsbD0iIzAwODAwMCIgb3BhY2l0eT0iMSIgZGF0YS1vcmlnaW5hbD0iIzAwMDAwMCIgY2xhc3M9IiI+PC9wYXRoPjwvZz48L3N2Zz4="
                  />
                </button>
                <span className="text-lg font-roboto">
                  Page {page} of {totalPages}
                </span>
                <button onClick={() => setPage(page + 1)} disabled={page === totalPages}>
                  <img
                    className="w-10"
                    alt=""
                    src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiB4PSIwIiB5PSIwIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTEyIDUxMiIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgY2xhc3M9IiI+PGc+PHBhdGggZD0iTTI1NiAwQzExNC44MzcgMCAwIDExNC44MzcgMCAyNTZzMTE0LjgzNyAyNTYgMjU2IDI1NiAyNTYtMTE0LjgzNyAyNTYtMjU2UzM5Ny4xNjMgMCAyNTYgMHptNzkuMDgzIDI3MS4wODNMMjI4LjQxNiAzNzcuNzQ5QTIxLjI3NSAyMS4yNzUgMCAwIDEgMjEzLjMzMyAzODRhMjEuMjc3IDIxLjI3NyAwIDAgMS0xNS4wODMtNi4yNTFjLTguMzQxLTguMzQxLTguMzQxLTIxLjgyNCAwLTMwLjE2NUwyODkuODM1IDI1NmwtOTEuNTg0LTkxLjU4NGMtOC4zNDEtOC4zNDEtOC4zNDEtMjEuODI0IDAtMzAuMTY1czIxLjgyNC04LjM0MSAzMC4xNjUgMGwxMDYuNjY3IDEwNi42NjdjOC4zNDEgOC4zNDEgOC4zNDEgMjEuODIzIDAgMzAuMTY1eiIgZmlsbD0iIzAwODAwMCIgb3BhY2l0eT0iMSIgZGF0YS1vcmlnaW5hbD0iIzAwMDAwMCIgY2xhc3M9IiI+PC9wYXRoPjwvZz48L3N2Zz4="
                  />
                </button>
              </div>
            </div>
   
      </div>
    </div>
  );
};

export default PaidInvoiceGreenAll;
